import CloseIcon from '@/assets/icons/CloseIcon';
import { StatusBadge } from '@/components/Common/StatusBadge/StatusBadge';
import COLORS from '@/constants/colors';
import { IconButton, Stack, Typography } from '@mui/material';
import {
  dividerStyle,
  fieldStyle,
  subSectionStyle,
  subTitleStyle,
} from '../../style';
import { OrderResumeHeader } from '../OrderResumeHeader/OrderResumeHeader';
import { useOrderResumeSectionViewController } from './OrderResumeSectionViewController';

export function OrderResumeSection(props: { closeClicked?: () => void }) {
  const { uiState } = useOrderResumeSectionViewController();

  if (uiState === undefined) return null;

  return (
    <Stack>
      <Stack
        sx={{
          display: { xs: 'auto', md: 'none' },
          flexDirection: { xs: 'row', md: 'row-reverse' },
          px: '16px',
        }}
      >
        <IconButton
          sx={{ mt: '16px' }}
          onClick={props.closeClicked}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </Stack>
      <Stack
        sx={{
          background: 'white',
          border: `1px solid ${COLORS.gray_6}`,
          borderRadius: '12px',
          width: {
            xs: '100%',
            md: '300px',
            lg: '400px',
          },
        }}
      >
        <OrderResumeHeader />
        <Stack sx={{ p: '16px' }}>
          <Stack direction={'row'}>
            <Stack sx={{ flexGrow: 1, flexShrink: 1 }}>
              <Typography sx={subTitleStyle}>Proveedor</Typography>
              <Typography sx={fieldStyle}>{uiState.sellerName}</Typography>
              <Typography sx={{ ...subTitleStyle, mt: '16px' }}>
                Comprador
              </Typography>
              <Typography sx={fieldStyle}>{uiState.client}</Typography>
            </Stack>
            <Stack sx={{ flexGrow: 1, flexShrink: 1 }}>
              <Typography sx={subTitleStyle}>Fecha de pedido</Typography>
              <Typography sx={fieldStyle}>{uiState.orderDate}</Typography>
              <Typography sx={{ ...subTitleStyle, mt: '16px' }}>
                Estatus de pedido
              </Typography>
              <StatusBadge
                badge={uiState.status}
                sx={{
                  width: 'fit-content',
                }}
              />
            </Stack>
          </Stack>
          <hr
            style={{ ...dividerStyle, marginTop: '16px', marginBottom: '16px' }}
          />
          <Stack>
            <Stack>
              <Typography sx={{ ...subSectionStyle, my: '12px' }}>
                Datos del envío
              </Typography>
            </Stack>
            <Typography sx={fieldStyle}>{uiState.deliversToAddress}</Typography>
            <hr
              style={{
                ...dividerStyle,
                marginTop: '16px',
                marginBottom: '8px',
              }}
            />
            <Typography sx={{ ...subSectionStyle, my: '12px' }}>
              Método de pago
            </Typography>
            <Stack direction={'row'} spacing={'8px'} alignItems={'center'}>
              <img
                src={uiState.paymentIcon}
                alt="Payment Icon"
                style={{ width: 24, height: 24, marginRight: 1 }}
              />
              <Typography sx={fieldStyle}>{uiState.paymentMethod}</Typography>
            </Stack>
          </Stack>
          <hr
            style={{ ...dividerStyle, marginTop: '16px', marginBottom: '16px' }}
          />
          <Stack>
            <Typography sx={{ ...subSectionStyle, my: '12px' }}>
              Desglose de pago
            </Typography>
            <Stack direction={'row'} justifyContent={'space-between'}>
              <Typography sx={subTitleStyle}>Subtotal de productos</Typography>
              <Typography sx={fieldStyle}>
                x{uiState.subTotalProductCount}
              </Typography>
              <Typography sx={fieldStyle}>${uiState.subTotalAmount}</Typography>
            </Stack>
            <Typography sx={{ ...subTitleStyle }}>IVA incluido *</Typography>
            <Stack direction={'row'} justifyContent={'space-between'}>
              <Typography sx={subTitleStyle}>Costo de envío</Typography>
              <Typography sx={fieldStyle}>$0.00</Typography>
            </Stack>
          </Stack>
          <hr
            style={{ ...dividerStyle, marginTop: '16px', marginBottom: '16px' }}
          />
          <Stack direction={'row'} justifyContent={'space-between'}>
            <Typography
              sx={{
                fontSize: '12px',
                fontWeight: '500',
                color: COLORS.mercanto_blue,
              }}
            >
              Total:
            </Typography>
            <Typography
              sx={{
                fontSize: '16px',
                fontWeight: '600',
                color: COLORS.blackish,
              }}
            >
              ${uiState.total}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}
